import { Button, styled } from '@mui/material';

const RedButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  padding: '10px 44px',
  border: '1px solid',
  lineHeight: 1.5,
  backgroundColor: '#FF0000',
  borderColor: '#FF0000',
  color: '#ffffff',
  fontFamily: 'SparkasseWeb',
  borderRadius: '21px',
  whiteSpace: 'nowrap',
  '&:hover': {
    backgroundColor: '#e60000',
    borderColor: '#e60000',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#e60000',
    borderColor: '#e60000',
  },
  '&:disabled': {
    boxShadow: 'none',
    backgroundColor: '#E3E3E3',
    borderColor: '#E3E3E3',
    color: '#969696',
  },
}) as typeof Button;

export default RedButton;
